export default "__VITE_ASSET__3qACPRcn__"